import React, { Component, useState, useEffect } from 'react';

import sortJsonArray from 'sort-json-array';

const News_app = () => {
	const [
		news,
		setNews
	] = useState([]);

	const [
		searchQuery,
		setSearchQuery
	] = useState('');

	const [
		url,
		setUrl
	] = useState('https://hn.algolia.com/api/v1/search?query=react');

	const [
		loading,
		setLoading
	] = useState(false);

	const fetchNews = () => {
		setLoading(true);
		fetch(url)
			.then((result) => result.json())
			.then(
				(data) => (
					setNews(sortJsonArray(data.hits, 'created_at', 'des')),
					setLoading(false),
					console.log('HERE', sortJsonArray(data.hits, 'created_at', 'des'))
				)
			)
			.catch((error) => console.error(error));
	};

	useEffect(
		() => {
			fetchNews();
		},
		[
			url
		]
	);

	const searchForm = (e) => {
		setSearchQuery(e.target.value);
	};

	const formSubmit = (e) => {
		e.preventDefault();
		setUrl(`https://hn.algolia.com/api/v1/search?query=${searchQuery}`);
	};

	const getDateTime = (str) => {
		let date = str.substring(0, 10);
		let time = str.substring(11, 16);

		let day = date.substring(8);
		let mnt = date.substring(5, 7);
		let yr = date.substring(0, 4);

		return [
			day + '-' + mnt + '-' + yr,
			time
		];
	};

	//2020-02-21

	const queryForm = () => (
		<form onSubmit={formSubmit}>
			<div class=''>
				<table className='' style={{ width: '100%' }}>
					<thead>
						<tr>
							<th>
								<input
									type='text'
									value={searchQuery}
									onChange={searchForm}
									placeholder='Search Tech Feeds'
									style={{ color: '#aaa', borderStyle: 'solid !important' }}
								/>
							</th>
							<th>
								<button type='submit' class='btn btn-primary bmd-btn-fab'>
									<i class='material-icons'>search</i>
								</button>
							</th>
						</tr>
					</thead>
				</table>
			</div>
			<br />
		</form>
	);

	const showLoading = () => (
		<div>
			{loading ? (
				<div>
					<div class='card'>
						<div className='card-body'>
							<div class='animate a1' />
							<div class='animate a2' />
							<div class='animate a3' />
							<div class='animate a4' />
						</div>
					</div>
					<br/>
					<div class='card'>
						<div className='card-body'>
							<div class='animate a1' />
							<div class='animate a2' />
							<div class='animate a3' />
							<div class='animate a4' />
						</div>
					</div>
					<br/>
					<div class='card'>
						<div className='card-body'>
							<div class='animate a1' />
							<div class='animate a2' />
							<div class='animate a3' />
							<div class='animate a4' />
						</div>
					</div>
					<br/>
					<div class='card'>
						<div className='card-body'>
							<div class='animate a1' />
							<div class='animate a2' />
							<div class='animate a3' />
							<div class='animate a4' />
						</div>
					</div>
					<br/>
					<div class='card'>
						<div className='card-body'>
							<div class='animate a1' />
							<div class='animate a2' />
							<div class='animate a3' />
							<div class='animate a4' />
						</div>
					</div>
					<br/>
					<div class='card'>
						<div className='card-body'>
							<div class='animate a1' />
							<div class='animate a2' />
							<div class='animate a3' />
							<div class='animate a4' />
						</div>
					</div>
					<br/>
					<div class='card'>
						<div className='card-body'>
							<div class='animate a1' />
							<div class='animate a2' />
							<div class='animate a3' />
							<div class='animate a4' />
						</div>
					</div>
					<br/>
					<div class='card'>
						<div className='card-body'>
							<div class='animate a1' />
							<div class='animate a2' />
							<div class='animate a3' />
							<div class='animate a4' />
						</div>
					</div>
					<br/>
					
					<br />
				</div>
			) : (
				''
			)}
		</div>
	);

	const nwesFeed = () => (
		<div>
			{/* {console.log('LOOK AT THIS', sortJsonArray([news], 'created_at', 'desc'))} */}
			{news.map((nws, index) => {
				if (nws.url !== null && nws.title !== null) {
					return (
						<div>
							<a
								href={nws.url}
								target='_blank'
								style={{ color: 'rgba(255,255,255,0.9)', textDecoration: 'none' }}
							>
								<div class='card'>
									<div key={index} class='card-body'>
										<sup class='text-muted'>
											<span class='quote'>{nws.url}</span>{' '}
										</sup>
										<br />
										{nws.title}
										<br />

										<small class='text-muted'>
											<em>By {nws.author}</em>
										</small>

										<br />
										<hr />
										<sub class='text-muted bg-dark'>
											<span style={{ float: 'right' }}>
												{getDateTime(nws.created_at)[1]} | {getDateTime(nws.created_at)[0]}
											</span>
										</sub>
									</div>
								</div>
							</a>

							<br />
						</div>
					);
				}
			})}
			<br />
			<center>
				<p className='text-muted'>
					<small>
						<small>- Thankyou for Visiting -</small>
					</small>
				</p>
			</center>
			<br />
		</div>
	);

	return (
		<div>
			{queryForm()}
			{showLoading()}
			{nwesFeed()}
		</div>
	);
};

export default News_app;
